import { render, staticRenderFns } from "./BuscarArticulos.vue?vue&type=template&id=020f7a16"
import script from "./BuscarArticulos.vue?vue&type=script&lang=js"
export * from "./BuscarArticulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports